// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import NodeViewModel from "./../../factories/node-view-model";
import ChildTabViewModel from "./../../../factories/child-tab-view-model";
import TabPage from "./../../../factories/tab-page";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-toolbar2";
import "./../../../bindings/sorting";
function UserDbConnectionTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.User = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.DbConnectionCollection = ko.observableArray([]);
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteUserDbConnection");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "UserDbConnectionAdd":
                self.ShowUserDbConnectionDialog();
                break;
            case "UserDbConnectionDelete":
                if (self.SelectedDbConnectionRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteUserDbConnection(self.SelectedDbConnectionRow().PrimaryKeyValue);
                        }
                    });
                }
                break;
        }
    };
    self.SelectedDbConnectionId = ko.observable();
    self.SelectedDbConnection = ko.observable();
    self.SelectedDbConnection.subscribe(function () {
        self.AddUserDbConnection(self.SelectedDbConnectionId(), self.User.UserId());
    });
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/UserTab/GetUserDbConnectionCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedDbConnectionRow(null);
            self.TotalRows(0);
            self.DbConnectionCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.DbConnectionCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            self.ToggleToolbarButtons();
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddUserDbConnection = function (dbConnectionId, userId) {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/UserTab/AddUserDbConnection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: userId,
            dbConnectionId: dbConnectionId
        }), function () {
            self.User.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.DeleteUserDbConnection = function (userDbConnectionId) {
        return Bao.post("Uadm/UserTab/DeleteUserDbConnection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userDbConnectionId: userDbConnectionId
        }), function () {
            self.User.TabPage.DirtyFlag(true);
            self.RefreshGrid();
        });
    };
    self.ShowUserDbConnectionDialog = function () { };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedDbConnectionRow = ko.observable({});
    self.SelectedDbConnectionRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "UserDbConnectionDelete":
                    button.Enabled(!(self.SelectedDbConnectionRow() == null));
                    break;
                case "UserDbConnectionAdd":
                    button.Enabled(!self.User.IsNew());
                    break;
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("Uadm/UserTab/ResetUserDbConnection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () {
        return Bao.post("Uadm/UserTab/SaveUserDbConnectionCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.Copy = function (userId, saveTime) {
        return Bao.post("Uadm/UserTab/CopyUserDbConnectionCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            newUserId: userId,
            saveTime: saveTime
        }));
    };
    self.init = function () {
        return self.RefreshGrid();
    };
    self.loaded = function () {
        self.ToggleToolbarButtons();
    };
}
;
export default UserDbConnectionTabModel;